export const faTexts = {
  // Titles
  encyclopediaTitle: "قالیچین - دانشنامه",
  insuranceAndServicesTitle: "قالیچین - بیمه و خدمات",
  generatorTitle: "قالیچین - چیدمان فرش",

  home: "خانه",
  contactUs: "ارتباط با ما",
  loginRegister: "ورود / ثبت نام",
  encyclopedia: "دانشنامه",
  vr: "واقعیت مجازی",
  buy: "خرید",
  loading: "در حال بارگذاری ...",
  rugGenerate: "چیدمان فرش",
  insuranceAndServices: "بیمه و خدمات",
  insurance: "بیمه",
  brand: "برند",
  shaneh: "شانه",
  density: "تراکم",
  yarn: "جنس",
  rug_size_6: "6 متری",
  rug_size_9: "9 متری",
  rug_size_12: "12 متری",
  decoration: "دکوراسیون",
  room_services: "سرویس ها",
  floor_covering: "کفپوش",
  wall: "دیوار",
  roof: "سقف",
  selectImage: "انتخاب تصویر",
  wishListText:
    "شما می توانید فرش های جدید شده را به لیست علاقه مندی ها اضافه کنید تا در مرحله بعد پیش نمایشی از آنها را ببینید",
  services: "خدمات",
  specialPosts: "مطالب منتخب",
  preview: "پیش نمایش",
  lachakToranj: "لچک ترنج",
  modern: "مدرن",
  afshan: "افشان",
  kheshti: "خشتی",
  border: "حاشیه",
  corner: "لچک",
  background: "زمینه",
  toranj: "ترنج",
  tile: "زمینه",
  pattern: "طرح",
  rugSettings: "کاشی",
  wishList: "لیست مورد علاقه",
  addToWishList: "افزودن به لیست مورد علاقه",
  listIsEmpty: "لیست خالی است",
  rotate: "چرخش",
  clear: "پاک کردن",
  latest: "جدیدترین",
  oldest: "قدیمی ترین",
  onSale: "حراج",
  searchingForSellers: "در حال جستجو برای فروشنده ها ...!",
  storesForThisRug: "فروشگاه هایی که این فرش را دارند",
  noStoreForSelectedRug: "فروشگاهی برای فرش انتخابی وجود ندارد!",
  selectOneSimilarRug: "لطفا یکی از فرش های مشابه را انتخاب کنید!",
  selectedRugs: "فرش های انتخاب شده",
  rugSimilarityPercentage: "درصد تشابه",
  similarRugs: "فرش های مشابه",
  availableRugSizes: "سایز های موجود",
  phoneNumber: "شماره تماس",
  address: "آدرس",
  filters: "فیلتر ها",

  previewEmptyHelpText: "باید یک فرش را به لیست اضافه کنید!",

  // Texts

  landingText: `ایجاد ارزش افزوده برای فرآیند خرید یکی از دغدغه های مهم اهالی هر کسب و کاری است. این ارزش افزوده از سه جهت مهم و قابل بررسی و اقدام است. از نقطه نظر مصرف کننده، از نقطه نظر فروشنده و در نهایت از نقطه نظر تولید کننده. قالیچین با هدف ایجاد این ارزش افزوده در یک بستر دیجیتالی و امن پا به میدان گذاشته است. رویکرد ما در قالیچین به این نحو است که خرید و فروش "کالای فرش" را در فضای جدید و قابل اعتماد ارائه کنیم.`,
  wikipediaBoldText: `فرق فرش ماشینی با دستباف چیه؟ برای انتخاب یه فرش با کیفیت به چه چیزهایی دقت کنم؟ چطور سایز فرش را انتخاب کنم؟ رنگ بندی فرش مناسب با دکور من کدومه؟ شانه و تراکم توی فرش ماشینی به چه معنی هست؟ رج توی فرش دستباف یعنی چی؟`,
  wikipediaLightText: `اطلاعات کافی قبل از اقدام به خرید یکی از ملزومات خرید هر کالایی به حساب می آید. قالیچین در بخش دانشنامه به دنبال پاسخ گویی به سوالات شما و ارائه ی صحیح ترین اطلاعات  در خصوص جنس، طرح، ظرافت، الیاف،رنگ ،ابعاد و طرح و نقش فرش می باشد.`,
  layOutBoldText:
    "ترنج فرش همسایه ام چه شکلی بود؟ قبول داری زمینه فرش شون خیلی به دکور خونه ما می اومد؟ کاش میشد بدون گشتن توی این مغازه تو خونه میشستم و جزئیات فرش ها رو با دقت می دیدم و فروشنده ها را هم خسته نمیکردم.",
  layOutLightText: `چیدمان در قالیچین سرویس ویژه و انحصاری ماست برای کسانی که علاقمند هستند با جزئیات فرش خود بازی کرده و نزدیک ترین فرش به انتخابشان را پیدا کرده و از نزدیک ترین فرشگاه به حل سکونتشان تهیه کنند.`,
  VRBoldText:
    "کاش میشد هر چهار تا طرح رو میگفتیم بیاره خونه و ما یکیش رو انتخاب کنیم ،فرش مدرن بیشتر به دکور ما میاد یا سنتی؟ فرش روی پارکت خوب میشه؟ ",
  VRLightText: `شاید برای شما هم پیش آمده که در هنگام خرید فرش از چند طرح خوشتان آمده باشد ولی این امکان برای شما وجود نداشته باشد که تمام این فرش ها را در منزلتان پهن کرده و نمای آنها را با دکوراسیون منزلتان ببینید و بهترین گزینه را انتخاب کنید. قالیچین برای این نیاز شما فکرهای زیادی دارد که این مسیر ار با شبیه سازی منزل شما آغاز کرده و ادامه خواهد داد.`,
  shoppingBoldText: `تو میدونی داری از کی خرید میکنی؟ میشه اعتماد کرد، کلاه برداری نباشه؟ از کجا معلوم فرش را بفرستن؟ حضوری بریم بهتر نیست؟`,
  shoppingLightText: ` ایجاد یک بستر امن برای داد و ستد کالا همیشه دغدغه مصرف کننده و فروشنده بوده است.اعتماد در فضای فروش اینترنتی به مراتب پیچیده تر است و این یکی از موانع گسترش این بازار به خصوص در مورد محصولات ارزشمند است. قالیچین تلاش نموده است با ایجاد سازو کار های مناسب بستر فروش امن و قابل اعتمادی را برای خرید فرش برای مصرف کنندگان و فروش فرش برای تامین کنندگان را فراهم نماید.`,
  insuranceBoldText:
    "کاش خودشون میبردن قالیشویی مطمئن؟ فرش ماشینی را کجا بدم بشورن که خراب نشه؟ کاش فرش کهنه ما را میگرفتن و با یه مبلغی با فرش نو تعویض میکردن! جایی هست که بتونم امشب برای مراسم فرش اجاره کنم؟ فرش نو هم اجاره میدن؟ ",
  insuranceLightText: `خدمات پس از فروش و ضمانت کالایی ارزشمند مانند فرش خرید را برای هر مشتری لذت بخش تر و مطمئن تر خواهد کرد. قالیچین با توجه به نیازهای مشتریان ضمن ارائه خدمات مختلف پس از فروش، خدمات ارزشمند دیگری را ارائه میدهد. خدماتی از قبیل شست و شوی رایگان! !تعویض فرش کهنه ی شما با فرش نو! و سرویس اجاره ی فرش برای استفاده کوتاه مدت شما از فرش!!!`,

  insuranceText:
    "همه ی ما علاقمندیم از جایی خرید کنیم که هم در زمان خرید بهترین گزینه ها را در اختیارمان بگذارد هم بعد از خرید از خدمات پس از فروش خوبی برخوردار باشد. قالیچین در این موضوع نیز خدمات گوناگونی را ارائه میدهد. به طور مثال مصرف کننده ای که فرش همراه با بیمه از قالیچین خریداری کرده باشد میتواند از اولین شست و شوی رایگان فرش اش بهره ببرد و یا بعد از مدتی اگر از فرش و انتخاب خود منصرف شد بواسطه ی قالیچین فرش کهنه را با پرداخت مبلغی بسیار کمتر از قیمت اولیه، با فرش نو و انتخاب جدید جایگزین کند. گزینه ی دیگر ما در خدمات بحث اجاره ی فرش خواهد بود که بزودی از جزئیات آن در قالیچین با خبر خواهید شد.",
  servicesText:
    "همه ی ما علاقمندیم از جایی خرید کنیم که هم در زمان خرید بهترین گزینه ها را در اختیارمان بگذارد هم بعد از خرید از خدمات پس از فروش خوبی برخوردار باشد. قالیچین در این موضوع نیز خدمات گوناگونی را ارائه میدهد. به طور مثال مصرف کننده ای که فرش همراه با بیمه از قالیچین خریداری کرده باشد میتواند از اولین شست و شوی رایگان فرش اش بهره ببرد و یا بعد از مدتی اگر از فرش و انتخاب خود منصرف شد بواسطه ی قالیچین فرش کهنه را با پرداخت مبلغی بسیار کمتر از قیمت اولیه، با فرش نو و انتخاب جدید جایگزین کند. گزینه ی دیگر ما در خدمات بحث اجاره ی فرش خواهد بود که بزودی از جزئیات آن در قالیچین با خبر خواهید شد.",
  firstLandingText: `به سفر مجازی مشتری سایت قالیچین خوش اومدین.
  در این سفر ما طی پنج بخش همراه تون هستیم. 
  اولین قدم کسب اطلاعات صحیح و قابل اعتماد در دانشنامه است. قدم دوم قراره خرید فرش رو براتون جذاب کنیم اونم با سرویس چیدمان فرش که امکان شخصی سازی فرش رو به شما میده. حالا توی قدم سوم یا همون واقعیت مجازی برای اطمینان بیشتر و خرید مجازی مطمئن تر میریم سراغ شبیه سازهای دو بعدی و سه بعدی جایی که شما بتونید فرش رو هماهنگ تر با دکوراسیون و منزل تون تهیه کنید. خیلی خوب. شما انتخاب تون رو کردید الان وقت قیمت و چونه زدنه. قدم چهارم خرید قالیچین یعنی بازارگاه قالیچین جایی هست که شما بهترین قیمت رو از نزدیک ترین محل پیدا میکنید و ثبت سفارش میکنید. 
  تبریک میگیم شما به هم قبیله ای های قالیچین اضافه شدین. بله درسته قدم پنجم این سفر تازه بعد از خرید تون شروع میشه قدم پنجم یا همون بیمه و خدمات که تعهدات ما به شما عضو جدید قالیچین هست.
  از اینکه قالیچین رو انتخاب کردید و همسفر ما شدید بسیار خرسندیم 
  امیدواریم خرید خوبی داشته باشید و از سفرتن لذت ببرید.
  بخش مورد نظرتون رو از نوار ابزار بالا انتخاب کنید. `,
  encyclopediaEndText: `دانشنامه:
  <br/>
  از تار و‌ پود تا طرح و‌ نقش 
  <br/>
  قدم اول هر خریدی داشتن اطلاعات کافی از محصول است.
  نخستین منبع اطلاعات ما در خرید یک محصول فروشندگان آن هستند. حالا این مسئله وجود دارد آیا تمام اطلاعاتی که فروشندگان به ما ارائه می کنند صحیح و قابل اعتماد است یا ما برای تصمیم گیری نیاز به یک منبع مطمئن تر داریم؟
  داشتن یک فضای چند رسانه ای برای معرفی محصولات نساجی و به طور خاص فرش توسط تولید کنندگان و فروشندگان  و فراهم کردن فضایی برای اشتراک نظرات مصرف کنندگان و بیان تجربه های خریدشان یک نقطه قوت برای خرید مطمئن می باشد 
  <br/>

  چند نمونه از مزیت های رقابتی ارائه شده در چنین بستری:
  <br/>
<br/>
  از دید مصرف کنندگان:
  <br/>

  آیا همه ی فروشندگان با شما صادق هستند؟ 
  <br/>

  آیا همه ی اطلاعاتی که به شما میدهند درست است؟
  <br/>
<br/>
  از دید فروشندگان:
  <br/>

  آیا محصولات فروشگاه شان به بهترین نحو معرفی میشود؟ 
  <br/>
  آیا جامعه آماری درستی آنها را میشناسند؟ 
  <br/>
  <br/>
 از دید تولید کنندگان:
 <br/>
  آیا مزیت رقابتی محصولاتی که تولید میکنند به قدر کافی معرفی و شناخته شده است؟ 
  <br/>
  آیا نیاز به معرفی در فضاهای جدید تری دارند؟
  `,
  generatorEndText: `چیدمان فرش:
  <br/>
  فرش و نقش 
  <br/>
  قدم دوم برای یک خرید مطمئن و قابل اعتماد ، لذت بخش بودن آن خرید و انتخاب کالا از سر رضایت است نه انتخاب از سر خستگی و محکوم یا مجبور به انتخاب بودن
  <br/>
  همه ی ما از کودکی با توجه به بستر فرهنگی و‌سبک زندگی مان با فرش و طرح و نقش آن آشنایی داریم 
  همین آشنایی بصری باعث میشود در هنگام خرید فرش صاحب نظرانی فرش شناس باشیم 
  اگر این امکان برای تمامی ما فراهم‌ بود که در طرح و‌ نقش قالی ها دخل و تصرفی داشته باشیم از این امکان قطعا بهره میبردیم 
  تا شاید از طراحی قالی خود به نقشه ی مطلوب تری برسیم و یا طرح شخصی خود را به آزمون و سنگ محک نقشه های اصیل ایرانی بگذاریم 
  در بخش چیدمان فرش قالیچین این امکان لذت بخش برای شما ایجاد شده تا طرح و نقش خودتان را شخصی سازی کنید و با بازی گونه سازی انتخاب نقشه راحت تر به طرح مورد علاقه ی خود برسید.
  علاوه بر این تحلیل و بررسی امکان بافت نقشه انحصاری شما نیز با عایت چند فاکتور ساده به راحتی امکان پذیر خواهد بود
  <br/>
  چند نمونه از مزیت های رقابتی ارائه شده در چنین بستری:
  <br/>
  <br/>
  از دید مصرف کنندگان:
  <br/>
  نقشه های بازار قابلیت تغییر و شخصی سازی دارند.
  <br/>
  نقشه ی طراحی شده توسط مشتری با نقشه های موجود بازار بررسی شده و نزدیک ترین نقشه ها به مشتری معرفی میشود
  <br/>
  <br/>
  از دید فروشندگان:
  <br/>
  بازی گونه سازی فرآیند خرید و جذاب تر شدن جریان انتخاب فرش
  <br/>
  اشتراک گذاری سلیقه مشتری در فرآیند خرید و تسهیل در امر انتخاب قالی
  <br/>
  <br/>
  از دید تولید کنندگان:
  <br/>
  تحلیل سلیقه مشتری بر اساس تکه های انتخابی و جهت دادن واحد طراحی به سمت ترند بازار
  <br/>
  هدف مند سازی تولید و ارائه ی بستر بافت نقشه های انحصاری مشتریان به صورت لیمیت ادیشن
  `,
  vrEndText: `
  واقعیت مجازی:
  <br/>
فرش و دکوراسیون 
<br/>
قدم سوم از سفر مجازی قالیچین شبیه سازی با ابزار های ۲ بعدی و ۳ بعدی است و ایجاد تور های مجازی برای فروشگاه هایی است که شاید به شما نزدیک‌ نباشند ولی شما علاقه مند هستید که از آنها بازدید کنید

همیشه یکی از دغدغه ها در خرید محصول هماهنگی کالا با سایر کالاهای منزل است 
حال که زمان انتخاب فرش رسیده این هماهنگی بسیار حائز اهمیت تر خواهد بود چراکه موضوع هماهنگی فرش با دکوراسیون منزل در میان است. یکی از راه حل ها پرو فرش در منزل هاست .
اما وقتی تعداد نقشه ها زیاد باشد و حمل و نقل فرش نیز یک معضل باشد تکنولوژی وارد عمل شده و‌ راه حل های ساده تری پیش پای ما میگذارد 
چند نمونه از مزیت های رقابتی ارائه شده در چنین بستری:
<br/>
<br/>
از دید مصرف کننده:
<br/>
مشاهده محصولات ارائه شده در فروشگاه ها بدون نیاز به تردد و رفت و آمد 
<br/>
مشاهده انواع طرح های قالی در فضای مورد نظر با استفاده از ایزار های شبیه سازی 
<br/>
<br/>
از دید توزیع کننده:
<br/>
بهره مندی از بستر های نرم افزاری برای جذب بازدید بیشتر از فروشگاه شان
<br/> 
استفاده از سامانه های تکنولوژیک برای کم کردن هزینه پرو فرش در منزل مشتری 
<br/>
<br/>
از دید تولید کننده:
<br/>
ایجاد تور مجازی از کارخانه و نمایش محصولات برای شبکه عمده فروشان
<br/> 
کوتاه و آسان کردن مسیر سفارش محصولات برای مغازه دارانی که امکان بازدید از کارخانه برای آنها دشوار است
`,
  buyEndText: `خرید:
  <br/>
  فرش و فروشگاه
  <br/>
  قدم چهارم از سفر مجازی قالیچین ارائه یک بازارگاه مجازی یا مارکت پلیس ای از برند هاست
  مشتری بعد از سه مرحله قبلی در این سفر مجازی به مرحله ی خرید که میرسد دچار نگرانی هایی از قبیل قیمت و ضمانت در کیفیت محصولات انتخابی خود خواهد بود
  در این شرایط بهره مندی از بازارگاهی که بتواند با خیال راحت و بدون صرف هزینه و وقت بررسی های قیمتی و کیفی خود را انجام دهد بسیار ضروری به نظر میرسد
  در این بازارگاه خرید های دیگران را رصد کنید ، رضایت مشتری ها را ببینید و از خدمات پس از فروش اطمینان حاصل کنید تا در نهایت با طیب خاطر بتوانید یک ثبت سفارش مناسب را از منزل خود و در کمال آرامش تجربه کنید
  <br/>
  چند نمونه از مزیت های رقابتی ارائه شده در چنین بستری:
  <br/>
  <br/>
  از دید مصرف کننده:
  <br/>
  بررسی قیمت کالاهای مورد نظر از چندین تامین کننده
  <br/>
  بررسی اعتبار و رضایت مشتری تامین کنندگان کالا بر اساس نظر سنجی خریداران قدیمی
  <br/>
  <br/>
  از دید توزیع کننده:
  <br/>
  ارائه ی محصولات خود در فضای مجازی بدون نیاز به ارسال نمونه و یا دپوی انبار
  <br/>
  تعامل پویا تر با مصرف کننده و راه اندازی و اطلاع رسانی فروش های ویژه
  <br/>
  <br/>
  از دید تولید کننده:
  <br/>
  ارائه سبد کالای محصولات تولید کننده در بازار بدون واسطه و دلال
  <br/>
  گرفتن فیدبک مستقیم از مصرف کننده نهایی و جهت دهی تولید بر اساس تقاضای بازار

  `,
  insuranceEndText: `بیمه و خدمات:
  <br/>
  فرش و آرامش
  <br/>
  قدم پنجم و آخرین گام از سفر مجازی مشتری اضافه شدن خریدار به قبیله ی قالیچینی هاست. 
  هیچ وقت فروش پایان ماجرا نیست. 
  یک کسب و کار هدفش فروش یک محصول یا خدمت به یک مشتری و تمام شدن این جریان نیست که اگر باشد نمی توان واژه موفق را برای آن استفاده کرد.
  هدف از ایجاد این بخش به صورت اختصاصی شبکه سازی است. شبکه ای از خدمات و تعاملات.
  بعد از خرید فرش نیاز های متفاوتی برای مشتری ایجاد خواهد شد. مانند شست و شو ، رفع ایرادات احتمالی و تعمیرات فرش ، داشتن گارانتی و ضمانت کیفیت و حتی بعد از مدتی استفاده از فرش نیاز به فروش فرش دست دوم و یا جایگزین کردن فرش قدیمی با فرش نو و به رزو بازار.
  تمامی این خدمات قابل ارائه می باشد در صورتی که نگاه صحیحی به فرآیند فروش داشته باشیم  برای ادامه ی فرآیند خدمات پس از فروش بستر های لازم را تدارک دیده باشیم.
  <br/>
  چند نمونه از مزیت های رقابتی ارائه شده در چنین بستری:
  <br/>
  <br/>
  از دید مصرف کننده:
  <br/>
  خرید مطمئن و ضمانت دار از یک مجموعه با خدمات چندجانبه
  <br/>
  ایجاد بستر بازار دست دوم و بازار فرش های تعویضی
  <br/>
  <br/>
  از دید توزیع کننده:
  <br/>
 بهره مندی از یک شبکه فروش منسجم و ادامه دار
 <br/>
  معرفی و شناسایی خود به مشتریان به عنوان یک واحد برتر در خدمات دهی
  <br/>
  <br/>
  از دید تولید کننده:
  <br/>
  در دنیای پر رقیب و پر شتاب کسب و کار ها ، خدمات بهتر و بیشتر معادل است با برند برتر و شناخته شده تر
  گسترش و توسعه باشگاه مشتریان 
  `,
  welcome:
    "به سفر مجازی مشتری سایت قالیچین خوش اومدین. در این سفر ما طی پنج بخش همراه تون هستیم.",
  hande_made: "فرش دستباف",
  machine: "فرش ماشینی",
  first_step: "اولین قدم کسب اطلاعات صحیح و قابل اعتماد در دانشنامه است.",
  scond_step:
    "مرحله دوم این است که با خدمات چیدمان فرش، خرید فرش را برای خود جذاب کنید که به شما امکان شخصی سازی فرش را می دهد.",
  market_carpet: "فرش بازار",
  your_own_carpet: "فرش خودت",
  your_photo: "عکس خودت",
  third_step: `حالا توی قدم سوم یا همون واقعیت مجازی برای اطمینان بیشتر و خرید مجازی مطمئن تر میریم سراغ شبیه سازهای دو بعدی و سه بعدی جایی که شما بتونید فرش رو هماهنگ تر با دکوراسیون و منزل تون تهیه کنید. خیلی خوب. شما انتخاب تون رو کردید الان وقت قیمت و چونه زدنه.`,
  virtual_tour: "تور مجازی",
  threeD: "سه بعدی",
  Two_dimensional: "دو بعدی",
  fourth_step:
    "قدم چهارم خرید قالیچین یعنی بازارگاه قالیچین جایی هست که شما بهترین قیمت رو از نزدیک ترین محل پیدا میکنید و ثبت سفارش میکنید. تبریک میگیم شما به هم قبیله ای های قالیچین اضافه شدین.",
  market: "بازار",
  gazette: "مجله",
  fifth_step: `بله درسته قدم پنجم این سفر تازه بعد از خرید تون شروع میشه. قدم پنجم یا همون بیمه و خدمات که تعهدات ما به شما عضو جدید قالیچین هست.`,
  secondhand: `بازار دست دوم`,
  replace: "تعویض کهنه با نو",
  inshurance: "بیمه فرش",
  size_selection: "انتخاب سایز",
  select_image: "انتخاب تصویر",
  confirm_and_pay: "تایید و ارسال",
  selection_size_description:
    "لطفا یکی از سایز های فرش مورد نظر خود را انتخاب کنید",
  image_registration: "ثبت تصویر",
  zoom: "بزرگنمایی",
  confirmation_and_approval: "تایید و ادامه",
  name_and_lastname: "نام و نام خانوادگی",
  Phone_call: "تلفن تماس",
  Address: "آدرس",
  send: "ارسال",
  ordering: "مرتب سازی",
  carpet_show: "نمایش فرش",
  back_market: "بازگشت به بازار",
  next: "بعدی",
  previous: "قبلی",
  carpet_link: "لینک فرش مورد نظرتان",
  national_Code: "کد ملی",
  upload_photo_and_video: "آپلود عکس و ویدیو از فرش خودتان",
  photoـorـvideoـlink: "لینک عکس یا فیلم",
  coming_back: "بازگشت",
  the_link_of_the_carpet_you_want: "لینک فرش مورد نظرتان",
  landing_tab:
    "برای معرفی کامل هر بخش از منو بالا و همچنین برای دسترسی سریعتر از منو پایین پایین استفاده کنید.",
  carpet_replacement: "تعویض فرش",
  submit: "ارسال",
  receiving_information: "در حال دریافت اطلاعات",
};
